// components/Registration/PersonalDetailsStep.js
import React, { useRef } from "react";
import { TextField, Button } from "@mui/material";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function PersonalDetailsStep({
  formData,
  setFormData,
  validateError,
  religions,
  castes,
  colors,
}) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const fileInputRef = useRef(null);
  const handleRemovePhoto = () => {
    setFormData(prev => ({
      ...prev,
      photopath: null,
      photoshow: null
    }));
    // Reset the file input
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes

      if (file.size > maxSize) {
        alert("File size must be less than 2MB!");
        event.target.value = ""; // clear the file input
        return;
      }
      const previewURL = URL.createObjectURL(file);
      setFormData((prev) => ({
        ...prev,
        photoshow: previewURL,
        photopath: file,
      }));
    }
  };

  const sexch = [
    { title: "Male", value: "Male" },
    { title: "Female", value: "Female" },
  ];

  const heights = [
    { title: "4ft 5in", value: "4ft 5in" },
    { title: "4ft 6in", value: "4ft 6in" },
    { title: "4ft 7in", value: "4ft 7in" },
    { title: "4ft 8in", value: "4ft 8in" },
    { title: "4ft 9in", value: "4ft 9in" },
    { title: "4ft 10in", value: "4ft 10in" },
    { title: "4ft 11in", value: "4ft 11in" },
    { title: "5ft", value: "5ft" },
    { title: "5ft 1in", value: "5ft 1in" },
    { title: "5ft 2in", value: "5ft 2in" },
    { title: "5ft 3in", value: "5ft 3in" },
    { title: "5ft 4in", value: "5ft 4in" },
    { title: "5ft 5in", value: "5ft 5in" },
    { title: "5ft 6in", value: "5ft 6in" },
    { title: "5ft 7in", value: "5ft 7in" },
    { title: "5ft 8in", value: "5ft 8in" },
    { title: "5ft 9in", value: "5ft 9in" },
    { title: "5ft 10in", value: "5ft 10in" },
    { title: "5ft 11in", value: "5ft 11in" },
    { title: "6ft", value: "6ft" },
    { title: "6ft 1in", value: "6ft 1in" },
    { title: "6ft 2in", value: "6ft 2in" },
    { title: "6ft 3in", value: "6ft 3in" },
    { title: "6ft 4in", value: "6ft 4in" },
    { title: "6ft 5in", value: "6ft 5in" },
    { title: "6ft 6in", value: "6ft 6in" },
    { title: "6ft 7in", value: "6ft 7in" },
    { title: "6ft 8in", value: "6ft 8in" },
    { title: "6ft 9in", value: "6ft 9in" },
    { title: "6ft 10in", value: "6ft 10in" },
    { title: "6ft 11in", value: "6ft 11in" },
    { title: "7ft", value: "7ft" },
  ];

  const differents = [
    { title: "Yes", value: "Yes" },
    { title: "No", value: "No" },
  ];
  return (
    <div>
      {/* Mobile Number */}
      <div style={{ margin: "1em 0" }}>
        <TextField
          fullWidth
          label="Mobile Number"
          name="phone_number"
          value={formData.phone_number}
          onChange={handleChange}
          error={!!validateError.phone_number}
          helperText={validateError.phone_number}
          variant="outlined"
          required
          FormHelperTextProps={{
            style: { fontSize: "14px", color: "red" },
          }}
          InputLabelProps={{
            sx: {
              ".MuiInputLabel-asterisk": {
                color: "red",
                fontSize: "1.2em",
              }
            }
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '16px',
            }
          }}
        />
      </div>

      {/* Name */}
      <div style={{ margin: "1em 0" }}>
        <TextField
          fullWidth
          label="Name"
          name="mname"
          value={formData.mname}
          onChange={handleChange}
          error={!!validateError.mname}
          helperText={validateError.mname}
          variant="outlined"
          FormHelperTextProps={{
            style: { fontSize: "14px", color: "red" },
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '16px',
            }
          }}
          InputLabelProps={{
            sx: {
              ".MuiInputLabel-asterisk": {
                color: "red",
                fontSize: "1.2em",
              }
            }
          }}
          required
        />
      </div>

      {/* Date of Birth and Place of Birth in a row */}
      {/* <div style={{ display: "flex", gap: "1em", margin: "1em 0" }}> */}
      <div style={{ flex: 1 }}>
        <DatePicker
          selected={formData.dob ? new Date(formData.dob) : null}
          onChange={(date) => setFormData((prev) => ({ ...prev, dob: date }))}
          dateFormat="dd/MM/yyyy"
          maxDate={new Date()}
          showYearDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={100}
          popperClassName="large-calendar" // Add this
          wrapperClassName="custom-wrapper"
          customInput={
            <TextField
              fullWidth
              label={<span>Date of Birth <span style={{ color: 'red' }}>*</span></span>}
              required
              error={!!validateError.dob}
              helperText={validateError.dob}
              variant="outlined"
              sx={{
                '& .MuiInputBase-input': {
                  fontSize: '16px',
                  padding: '16px',
                  height: '17px',
                  // width: '34rem',
                }
              }}
              FormHelperTextProps={{
                style: { fontSize: "14px", color: "red" },
              }}
            />
          }
        />
      </div>

      <div style={{ margin: "1em 0" }}>
        <TextField
          fullWidth
          label="Place of Birth"
          name="place_of_birth"
          value={formData.place_of_birth}
          onChange={handleChange}
          error={!!validateError.place_of_birth}
          helperText={validateError.place_of_birth}
          variant="outlined"
          FormHelperTextProps={{
            style: { fontSize: "14px", color: "red" },
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '16px',
            }
          }}
          InputLabelProps={{
            sx: {
              ".MuiInputLabel-asterisk": {
                color: "red",
                fontSize: "1.2em",
              }
            }
          }}
          required
        />
      </div>
      {/* </div> */}

      {/* Gender, Height, Religion, and Caste in a row */}
      {/* <div style={{ display: "flex", gap: "1em", margin: "1em 0" }}> */}
      <div style={{ margin: "1em 0" }}>

        <Autocomplete
          options={sexch || []}
          getOptionLabel={(o) => (o?.title ? o.title : "")}
          getOptionSelected={(option, value) => option?.value === value?.value}
          value={formData.sex || null}
          onChange={(e, v) => setFormData((prev) => ({ ...prev, sex: v }))}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label="Gender"
              error={!!validateError.sex}
              helperText={validateError.sex}
              variant="outlined"
              FormHelperTextProps={{
                style: { fontSize: "14px", color: "red" },
              }}
              InputLabelProps={{
                sx: {
                  ".MuiInputLabel-asterisk": {
                    color: "red",
                    fontSize: "1.2em",
                  }
                }
              }}
              required
            />
          )}
        />
      </div>

      {/* color */}
      <div style={{ margin: "1em 0" }}>

        <Autocomplete
          options={colors || []}
          getOptionLabel={(o) => (o?.title ? o.title : "")}
          getOptionSelected={(option, value) => option?.value === value?.value}
          value={formData.colorname || null}
          onChange={(e, v) => setFormData((prev) => ({ ...prev, colorname: v }))}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label="Color"
              error={!!validateError.colorname}
              helperText={validateError.colorname}
              variant="outlined"
              FormHelperTextProps={{
                style: { fontSize: "14px", color: "red" },
              }}

            />
          )}
        />
      </div>

      <div style={{ margin: "1em 0" }}>
        <Autocomplete
          options={heights || []}
          getOptionLabel={(option) => option.title}
          onChange={(event, newValue) => {
            setFormData((prev) => ({ ...prev, height: newValue?.value }));
          }}
          value={formData.height ? { title: formData.height, value: formData.height } : null}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label="Height"
              variant="outlined"
              error={!!validateError.height}
              helperText={validateError.height}
              FormHelperTextProps={{
                style: { fontSize: "14px", color: "red" },
              }}
              InputLabelProps={{
                sx: {
                  ".MuiInputLabel-asterisk": {
                    color: "red",
                    fontSize: "1.2em",
                  }
                }
              }}
              required
            />
          )}
        />
      </div>

      <div style={{ margin: "1em 0" }}>
        <Autocomplete
          options={differents || []}
          getOptionLabel={(option) => option.title}
          onChange={(event, newValue) => {
            setFormData((prev) => ({ ...prev, different: newValue?.value }));
          }}
          value={formData.different ? { title: formData.different, value: formData.different } : null}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label="Differently Abled"
              variant="outlined"
              error={!!validateError.different}
              helperText={validateError.different}
              FormHelperTextProps={{
                style: { fontSize: "14px", color: "red" },
              }}
            />
          )}
        />
      </div>
      {/* </div> */}

      {/* <div style={{ display: "flex", gap: "1em", margin: "1em 0" }}> */}
      <div style={{ margin: "1em 0" }}>

        <Autocomplete
          options={religions || []}
          getOptionLabel={(o) => (o?.title ? o.title : "")}
          getOptionSelected={(option, value) => option?.value === value?.value}
          value={formData.religion || null}
          onChange={(e, v) => setFormData((prev) => ({ ...prev, religion: v }))}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label="Religion"
              error={!!validateError.religion}
              helperText={validateError.religion}
              variant="outlined"
              FormHelperTextProps={{
                style: { fontSize: "14px", color: "red" },
              }}
              InputLabelProps={{
                sx: {
                  ".MuiInputLabel-asterisk": {
                    color: "red",
                    fontSize: "1.2em",
                  }
                }
              }}
              required
            />
          )}
        />
      </div>
      <div style={{ margin: "1em 0" }}>

        <Autocomplete
          options={castes || []}
          getOptionLabel={(o) => (o?.title ? o.title : "")}
          getOptionSelected={(option, value) => option?.value === value?.value}
          value={formData.castename || null}
          onChange={(e, v) => setFormData((prev) => ({ ...prev, castename: v }))}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label="Caste"
              error={!!validateError.castename}
              helperText={validateError.castename}
              variant="outlined"
              FormHelperTextProps={{
                style: { fontSize: "14px", color: "red" },
              }}
              InputLabelProps={{
                sx: {
                  ".MuiInputLabel-asterisk": {
                    color: "red",
                    fontSize: "1.2em",
                  }
                }
              }}
              required
            />
          )}
        />
      </div>
      {/* </div> */}

      {/* Subcaste and Residence in a row */}
      {/* <div style={{ display: "flex", gap: "1em", margin: "1em 0" }}> */}
      <div style={{ margin: "1em 0" }}>

        <TextField
          fullWidth
          label="Subcaste"
          name="subcaste"
          value={formData.subcaste}
          onChange={handleChange}
          variant="outlined"
          FormHelperTextProps={{
            style: { fontSize: "14px", color: "red" },
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '16px',
            }
          }}
        />
      </div>
      <div style={{ margin: "1em 0" }}>

        <TextField
          fullWidth
          label="Place of Residence"
          name="place_of_residence"
          value={formData.place_of_residence}
          onChange={handleChange}
          error={!!validateError.place_of_residence}
          helperText={validateError.place_of_residence}
          variant="outlined"
          FormHelperTextProps={{
            style: { fontSize: "14px", color: "red" },
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '16px',
            }
          }}
          InputLabelProps={{
            sx: {
              ".MuiInputLabel-asterisk": {
                color: "red",
                fontSize: "1.2em",
              }
            }
          }}
          required
        />
      </div>
      {/* </div> */}

      {/* Self Description */}
      <div style={{ margin: "1em 0" }}>
        <TextField
          fullWidth
          label="Self Expression / Self Description"
          name="self_description"
          value={formData.self_description}
          onChange={handleChange}
          error={!!validateError.self_description}
          helperText={validateError.self_description}
          variant="outlined"
          multiline
          rows={4}
          FormHelperTextProps={{
            style: { fontSize: "14px", color: "red" },
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '16px',
            }
          }}
        />
      </div>

      {/* Profile Photo */}
      <div style={{ margin: "1em 0" }}>
        {formData.photoshow && (
          <div style={{ marginBottom: "8px" }}>
            <img
              src={formData.photoshow}
              alt="Profile"
              style={{
                maxWidth: "120px",
                borderRadius: "8px",
                marginBottom: "8px"
              }}
            />
            <Button
              variant="outlined"
              color="error"
              size="large"
              onClick={handleRemovePhoto}
              style={{ marginLeft: "8px" }}
            >
              Remove
            </Button>
          </div>
        )}
        <p style={{ fontSize: "14px" }}>Maximum file size : 2MB</p>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          component="label"
          style={{
            padding: "14px",
            fontSize: "1rem",
            fontWeight: "bold",
            borderRadius: "6px",
            background: "#B21919",
            color: "#FFFFFF"
          }}
        >
          {formData.photopath ? "Change Photo" : "Upload Photo"}
          <input
            type="file"
            accept="image/*"
            hidden
            onChange={handleFile}
            ref={fileInputRef} // Add the ref here
          />
        </Button>
      </div>
    </div>
  );
}
